import React from 'react';
import styles from './style.module.scss';
import GrayContainer from "../components/GrayContainer";
import TitleWithDashedLine from "../components/TitleWIthDashedLine";
import { Link } from "react-router-dom";
import { getImagePath } from '../getImagePath';
// Container
import ArticleList from '../../Series/ArticleList';
import ResourceLinks from '../../Series/ResourceLinks';


function ThemesSection() {
    return (
        <GrayContainer className={styles.grayContainer}>
            <div className={styles.wrapper}>
            <TitleWithDashedLine as="h3" text="主題館" />
                <div className={styles.customArticleList}>       
                    <ArticleList color="purple" categoryID={11} pathname="/statistics/ChishangEarthquake"></ArticleList>
                </div>
                <Link to="/statistics/ChishangEarthquake/categories" className={`${styles.more} sectionbutton fill-button`}>
                    <span className="type-text -ch -md">進入主題館</span>
                </Link>
            </div>
        </GrayContainer>
    );
}

export default ThemesSection;